import Sparkle from "./character/sparkle.es6";
import Meteor from "./character/meteor.es6";
import Slider from "./character/slider.es6";

const sparkle = new Sparkle();
const meteor = new Meteor();
const slider = new Slider();
